import { UserRole } from '@edl-development/edl-common';
import { RatingFormCreateDTO } from './../../model/observation/rating-form/rating-form-create.model';
import { RatingFormApi } from './../../api/observations/ratingform-api';
import { Injectable } from '@angular/core';
import { RatingDetailsModel } from 'src/app/model/observation/rating-form/rating-details.model';
import { BaseUserRoleDTO } from 'src/app/model/base/base-user-role-dto.model';
import { UserHelper } from 'src/app/model/helpers/user.helper';
import { RatingFormAdminAction } from 'src/app/model/observation/rating-form/admin-action.model';
@Injectable()
export class RatingFormService {


  constructor(private ratingFormApi: RatingFormApi) { }

  getObservationDetails = (userId: string, ratingId: string) =>
    this.ratingFormApi.getDetails(userId, ratingId);

  createRatingForm = (model:RatingFormCreateDTO) =>
    this.ratingFormApi.createRatingForm(model);

  saveRatingForm = (model:RatingDetailsModel) =>
    this.ratingFormApi.saveRatingForm(model);

  attachSignature = (ratingId:string, location:number) =>
    this.ratingFormApi.attachSignature(ratingId, location);

  getValidFormTypes(targetUserRoles: BaseUserRoleDTO[]):Array<{ value: string, label: string }>{
    let response = new Array<{ value: string, label: string }>();
    if (UserHelper.isSupervisorCurriculumInstruction(targetUserRoles)) {
      response.push({label:"13-2", value:"2"});
      response.push({label:"13-4 Interim", value:"42"});
    } else {
      for(let role of targetUserRoles){
        switch(role.roleName){
          case "Teacher":
            response.push({label:"13-1", value:"1"});
            response.push({label:"13-4 Interim", value:"41"});
            break;
          case "NTPE":
          case "NTPE_Supervisor":
              response.push({label:"13-3", value:"3"});
              response.push({label:"13-4 Interim", value:"43"});
            break;
          case "Building_Principal":
              response.push({label:"13-2", value:"2"});
              response.push({label:"13-4 Interim", value:"42"});
              break;
        }
      }
    }

    return response.filter((role,i,arr) => arr.findIndex(t=> t.value === role.value) === i);

  }

  removeSignature= (ratingId:string, location: number) =>
    this.ratingFormApi.removeSignature(ratingId,location);


  getAdminActions = (increment:number = 10, index:number = 0) =>
    this.ratingFormApi.getAdminActions(increment, index);

  createAdminAction = (action:RatingFormAdminAction  ) =>
    this.ratingFormApi.createAdminAction(action);

}
